/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const AtomoNumbToken = ({
  className,
  elementClassName,
  text = "0",
  hasElement = true,
}) => {
  return (
    <div className={`atomo-numb-token ${className}`}>
      {hasElement && (
        <div className={`element ${elementClassName}`}>{text}</div>
      )}
    </div>
  );
};

AtomoNumbToken.propTypes = {
  text: PropTypes.string,
  hasElement: PropTypes.bool,
};
